<template>
  <div>
    <div class="banner" v-if="banner.length!==0">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banner" :key="index"><a style="cursor: pointer"
                                                                                   @click="navTo(item)"><img
              :src="$baseURL + item.imgUrl"></a></div>
          <!--          <div class="swiper-slide"><a href="#"><img src="images/banner.jpg"></a></div>-->
          <!--          <div class="swiper-slide"><a href="#"><img src="images/banner.jpg"></a></div>-->
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="homepage">
      <div class="container">
        <div class="a">
          <div class="hd">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in swiper" :key="item.id" @click="toDetail2(item)"><a
                    style="cursor: pointer;">{{ item.title }}</a></div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
          </div>
          <div class="bd">
            <div class="clearfix row">
              <div class="col-5">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="item in cards" :key="item.id">
                      <a @click="toDetail2(item)"><img :src="$baseURL + item.imgUrl" style="height: 378px"></a>
                      <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding-right: 140px">
                        {{ item.title }}</p>
                    </div>
                  </div>

                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                </div>
              </div>

              <div class="col-5">
                <div class="box">
                  <ul class="tabtitle flex">
                    <li :class="{on:index==tabIndex1}" @click="tabClick1(index)" v-for="(item,index) in allData[0]"
                        :key="index">{{ item.name }}
                    </li>
                    <a href="javascript:;" class="more" @click="toMore(allData[0][tabIndex1])">
                      {{ style == 1 ? '更多' : 'MORE' }}</a>
                  </ul>
                  <div class="tabcontent" v-if="allData[0] && allData[0][tabIndex1]">
                    <!--列表模型-->
                    <div class="tabbox" v-if="allData[0][tabIndex1].showType == 0">
                      <ul class="newslist">
                        <li v-for="item in allData[0][tabIndex1].articles.slice(0,6)" :key="item.id">
                          <div class="flex_item"><a @click="toDetail(allData[0][tabIndex1],item.id,item)">
                            <span style="color: red;" v-if="item.isTop==1">【 {{ style == 1 ? '顶' : 'TOP' }} 】</span>
                            {{ item.title }}
                          </a></div>
                          <span>{{ item.publishTime | format }}</span>
                        </li>
                      </ul>
                    </div>
                    <!--栏目模型1-->
                    <div class="tabbox" v-else-if="allData[0][tabIndex1].showType == 1">
                      <ul class="newslist">
                        <li v-for="item in allData[0][tabIndex1].columns.slice(0,6)" :key="item.id">
                          <div class="flex_item"><a style="font-weight: bold"
                                                    @click="toMore2(allData[0][tabIndex1],item.id)">{{ item.name }}</a>
                          </div>
                          <span>{{ item.createTime | format }}</span>
                        </li>
                      </ul>
                    </div>
                    <!--栏目模型2-->
                    <div class="tabbox" v-else-if="allData[0][tabIndex1].showType == 2">
                      <div class="box1">
                        <div class="box-item" @click="toMore2(allData[0][tabIndex1],item.id)"
                             v-for="item in allData[0][tabIndex1].columns.slice(0,6)" :key="item.id">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!--        固定的合作伙伴-->
        <!--        <div class="d" v-if="partner.length>0" style="margin-top: 30px">-->
        <!--          <div class="title flex" v-if="stations && stations.id != 1">-->
        <!--            <div class="flex_item"><b>{{stations && stations.id == 1004 ? '服务平台' : '合作伙伴'}}</b></div>-->
        <!--            &lt;!&ndash;            <a href="#" class="more">{{style == 1 ? '更多':'MORE'}}</a>&ndash;&gt;-->
        <!--          </div>-->
        <!--          <div class="box">-->
        <!--            <ul class="clearfix">-->
        <!--              <li v-for="item in partner.slice(0,4)" :key="item.id">-->
        <!--                <a :href="item.pathUrl" target="_blank">-->
        <!--                  <div class="pic"><img :src="$baseURL + item.imgUrl"></div>-->
        <!--                  <p>{{item.name}}</p>-->
        <!--                </a>-->
        <!--              </li>-->
        <!--            </ul>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="fw">
          <div class="cont_sec" v-if="partner.length>0">
            <div class="title flex">
              <img class="fwimg" src="../assets/images/fanw.png" alt="">
              <div class="fwtitle">业务范围</div>
            </div>
            <ul class="fwul">
              <li class="item1 img-hover-effect" id="product" onclick="goProduct(1)" v-for="item in partner.slice(0,4)"
                  :key="item.id"
                  :style="{background: `url(${$baseURL + item.imgUrl}) no-repeat`,'background-size': '100% 100%'}"
                  @click="getadd(item)">
                <p class="imgIcon" style="margin-left: 44px;">
                  <img src="../assets/images/blckRightIcon.png">
                </p>
                <p class="names">{{ item.name }}</p>
                <p class="mengBan"></p>
              </li>
            </ul>
          </div>
        </div>

        <div class="a" style="margin-top: 30px">
          <div class="row clearfix bd" style="display: flex">

            <div class="col-5">
              <div class="box" style="min-height: 380px">
                <ul class="tabtitle flex">
                  <li :class="{on:index==tabIndex11}" @click="tabClick11(index)" v-for="(item,index) in allData[1]"
                      :key="index">{{ item.name }}
                  </li>
                  <a href="javascript:;" class="more" @click="toMore(allData[1][tabIndex11])">
                    {{ style == 1 ? '更多' : 'MORE' }}</a>
                </ul>
                <div class="tabcontent" v-if="allData[1] && allData[1][tabIndex11]">
                  <!--列表模型-->
                  <div class="tabbox" v-if="allData[1][tabIndex11].showType == 0">
                    <ul class="newslist">
                      <li v-for="item in allData[1][tabIndex11].articles.slice(0,6)" :key="item.id">
                        <div class="flex_item"><a @click="toDetail(allData[1][tabIndex11],item.id,item)">
                          <span style="color: red;" v-if="item.isTop==1">【 {{ style == 1 ? '顶' : 'TOP' }} 】</span>
                          {{ item.title }}
                        </a></div>
                        <span>{{ item.publishTime | format }}</span>
                      </li>
                    </ul>
                  </div>
                  <!--栏目模型1-->
                  <div class="tabbox" v-else-if="allData[1][tabIndex11].showType == 1">
                    <ul class="newslist">
                      <li v-for="item in allData[1][tabIndex11].columns.slice(0,6)" :key="item.id">
                        <div class="flex_item"><a style="font-weight: bold"
                                                  @click="toMore2(allData[1][tabIndex11],item.id)">{{ item.name }}</a>
                        </div>
                        <span>{{ item.createTime | format }}</span>
                      </li>
                    </ul>
                  </div>
                  <!--栏目模型2-->
                  <div class="tabbox" v-else-if="allData[1][tabIndex11].showType == 2">
                    <div class="box1">
                      <div class="box-item" @click="toMore2(allData[1][tabIndex11],item.id)"
                           v-for="item in allData[1][tabIndex11].columns.slice(0,6)" :key="item.id">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="yw">
              <div class="name">业务平台</div>
              <div class="xian"></div>
              <div class="boxs2">

                <a class="nrr" :class="{ 'adaptive': outers.length > 6 }" :style="{ backgroundColor: getBackgroundColor(index)  }"  v-for=" (item,index) in outers"
                :key="index" :href="item.pathUrl" target="_blank">
                  <img src="../assets/images/c1.png" alt="" v-if="index >= 5">
                  <img :src="require(`../assets/images/c${Number(index) + 1}.png`)  " alt="" v-else>
                <div class="title">
                  {{ item.name }}
                </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="c" v-if="allData.length>0 && allData[3].length > 0">
          <div class="box">
            <div class="flex" style="width: 100%">
              <ul class="tabtitle">
                <li :class="{on:index==tabIndex2}" @click="tabClick2(index)" v-for="(item,index) in allData[3]"
                    :key="item.id">
                  <i :class="`i${index+1}`"></i>
                  <p style="font-weight:bold;">{{ item.name }}</p>
                </li>
              </ul>
              <div class="tabcontent flex_item">
                <div class="tabbox">
                  <div class="flex"
                       v-if="allData.length>0 && allData[3] && allData[3][tabIndex2] && allData[3][tabIndex2]">
                    <div style="width: 240px;height: 253px;margin: 0 50px">
                      <!-- <template v-if="adv5[tabIndex2]">
                        <a @click="navTo(adv5[tabIndex2])"><img style="margin: 0 !important;" :src="$baseURL + adv5[tabIndex2].imgUrl"></a>
                      </template> -->
                      <template>
                        <a @click="navTo(adv5[tabIndex2])"><img style="margin: 0 !important;"
                                                                :src="$baseURL + adv5[0].imgUrl"></a>
                      </template>
                    </div>
                    <div class="flex_item">
                      <ul class="newslist">
                        <li v-for="item in allData[3][tabIndex2].articles.slice(0,5)" :key="item.id">
                          <div class="flex_item"><a href="javascript:;"
                                                    @click="toDetail(allData[3][tabIndex2],item.id,item)">
                            {{ item.title }}
                            <!--<span>2018年修正本</span>-->
                          </a></div>
                          <span>{{ item.publishTime | format }}</span>
                        </li>
                      </ul>
                      <div class="ft">
                        <a href="javascript:;" @click="toMore(allData[3][tabIndex2])">
                          {{ style == 1 ? '查看更多......' : 'MORE.....' }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="e" v-if="allData.length>0 && allData[4] && allData[4][tabIndex3]">
          <div class="row clearfix">
            <div class="col-5">
              <div class="box" v-if="allData.length>0 && allData[4] && allData[4][tabIndex3]">
                <ul class="flex tabtitle">
                  <li :class="{on:index==tabIndex3}" @click="tabClick3(index)" v-for="(item,index) in allData[4]"
                      :key="index" style="font-weight:bold;">{{ item.name }}
                  </li>
                  <a href="javascript:;" @click="toMore(allData[4][tabIndex3])"
                     class="more">{{ style == 1 ? '更多' : 'MORE' }}</a>
                </ul>
                <div class="tabcontent" v-if="allData[4][tabIndex3].showType == 0">
                  <div class="tabbox">
                    <ul class="newslist">
                      <li v-for="item in allData[4][tabIndex3].articles.slice(0,6)" :key="item.id">
                        <div class="flex_item"><a href="javascript:;" @click="toDetail(allData[4][tabIndex3],item.id.item)">
                          <span style="color: red;" v-if="item.isTop==1">【{{ style == 1 ? '顶' : 'TOP' }}】</span>
                          {{ item.title }}</a></div>
                        <template v-if="allData[4][tabIndex3].name =='培训计划'">
                          <button v-if="boolTime(item.endTime)" type="button" class="btn"
                                  @click.stop.prevent="toPlan(item.id)">我要申请
                          </button>
                          <span v-else>已结束</span>
                        </template>
                        <template v-else>
                          <span>{{ parseTime('', item.createTime) }}</span>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="tabcontent" v-else-if="allData[4][tabIndex3].showType == 1">
                  <div class="tabbox">
                    <ul class="newslist">
                      <li v-for="item in allData[4][tabIndex3].columns.slice(0,6)" :key="item.id">
                        <div class="flex_item"><a href="javascript:;" style="font-weight: bold"
                                                  @click="toMore2(allData[4][tabIndex3],item.id)">{{ item.name }}</a>
                        </div>
                        <span>{{ item.createTime | format }}</span>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-5 right" v-if="allData.length > 0 && allData[5] && allData[5][0] && allData[5][0]">
              <div class="title flex">
                <div class="flex_item"><b>{{ allData[5][0].name }}</b></div>
                <a href="javascript:;" @click="toMore(allData[5][0])"
                   class="more">{{ style == 1 ? '更多' : 'MORE' }}</a>
              </div>

              <div class="box" v-if="allData[5][0].showType == 0">
                <template v-if="adv6[0]">
                  <a @click="navTo(adv6[0])"><img :src="$baseURL + adv6[0].imgUrl"></a>
                </template>
                <ul class="newslist">
                  <li v-for="item in allData[5][0].articles.slice(0,3)" :key="item.id">
                    <div class="flex_item"><a href="javascript:;" @click="toDetail(allData[5][0],item.id,item)">
                      <span style="color: red;" v-if="item.isTop==1">【{{ style == 1 ? '顶' : 'TOP' }}】</span>
                      {{ item.title }}</a></div>
                    <span>{{ item.publishTime | format }}</span>
                  </li>
                </ul>
              </div>
              <div class="box" v-else-if="allData[5][0].showType == 1">
                <template v-if="adv6[0]">
                  <a @click="navTo(adv6[0])"><img :src="$baseURL + adv6[0].imgUrl"></a>
                </template>
                <ul class="newslist">
                  <li v-for="item in allData[5][0].columns.slice(0,3)" :key="item.id">
                    <div class="flex_item"><a href="javascript:;" style="font-weight: bold;"
                                              @click="toMore2(allData[5][0],item.id)">{{ item.name }}</a></div>
                    <span>{{ item.createTime | format }}</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div class="f" v-if="fLinks.length>0">
          <div class="title flex">
            <div class="flex_item"><b>{{ style == 1 ? '友情链接' : 'Friendship links' }}</b></div>
            <!--            <a href="#" class="more">{{style == 1 ? '更多':'MORE'}}</a>-->
          </div>
          <div class="box">
            <ul class="clearfix">
              <li v-for="item in fLinks" :key="item.id"><a :href="item.pathUrl" target="_blank"><img
                  :src="$baseURL + item.imgUrl"></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--      <float-view  :json="json" @closeView="closeView"></float-view>-->
  </div>
</template>

<script>
import {loadSwiper} from "@/libs";

import {mapMutations, mapState} from 'vuex'
import {parseTime} from "@/libs/utils";

export default {
  name: "home",
  data() {
    return {
      showView: true,
      banner: [],
      adv2: [],
      adv3: [],
      adv4: [],
      adv5: [],
      adv6: [],
      swiper: [],
      cards: [],
      tab1: ['通知公告', '认证业务'],
      certData: [],//
      tabIndex1: 0,
      tabData1: [],
      hydt: [],
      gzdt: [],
      tab2: ['法律法规', '公开文件', '证书公告'],
      tabIndex2: 0,
      tabData2: [],
      partner: [],
      tab3: ['培训计划', '资料下载'],
      tabIndex3: 0,
      tabData3: [],
      zspj: [],
      fLinks: [],
      allData: [],
      inners: [],
      outers: [],
      style: 1,
      phonesList: [],
      tabIndex11: 0
    }
  },
  activated() {
    this.setShowTips(true)
    $("#left").show();
    $("#right").show();
    $("#float").show()
    setTimeout(() => {
      loadSwiper();
    }, 100)
  },
  mounted() {
    this.style = process.env.VUE_APP_BASE_STYLE
    //加载执行轮播加载
    this.getBanner()
    //滚动横幅
    this.getSwiper()
    //卡片轮播
    this.getCards()
    //公告栏
    // this.getBulletin();
    // this.getTab1();
    // this.gethydt();
    // this.getgzdt();
    // this.getTab2();
    this.getPartner()
    // this.getTab3();
    // this.getzspj();
    this.getFriendLink()
    this.getIndexColumn();
    this.getBsList()
    this.getfindPhones()
  },
  filters: {
    format(x) {
      return x.split(" ")[0]
    }
  },
  computed: {
    ...mapState(['stations'])
  },
  methods: {
    async getBsList() {
      let data = {
        l: this.style == 1 ? 'cn' : 'en'
      }
      let res = await this.$api.getBsList(data)
      console.log(res.data.data, 'bs===')
      res.data.data.forEach(item => {
        if (item.type == 1) {
          this.inners.push(item)
        } else {
          this.outers.push(item)
        }
      })
    },
    ...mapMutations(['setShowTips']),
    parseTime,
    toPlan(id) {
      this.$router.push('/channels/374/393.html?planId=' + id)
    },
    boolTime(date) {
      let listDate = new Date(date);
      let now = new Date();
      return now - listDate
    },
    closeView() {
      this.showView = false;
    },
    async getIndexColumn() {
      let res = await this.$api.getIndexColumn();
      console.log('获取全部的内容为', res.data.data);
      this.allData = res.data.data;
      $(".app-loading").hide()
    },
    toCatePage(item, index) {
      this.$router.push({
        path: '/management',
        query: {
          id: item.id,
          pid: item.parentId,
          index: index,
          name: this.tab1[this.tabIndex1]
        }
      })
      this.$store.commit('setTabIndex', 4)
    },

    //获取轮播数据
    async getBanner() {
      let res = await this.$api.getTopBanner({type: "1,2,3,4,5,6"});
      res.data.data.forEach(item => {
        if (item.locationType == 1) {
          this.banner.push(item)
        } else if (item.locationType == 2) {
          this.adv2.push(item)
        } else if (item.locationType == 3) {
          this.adv3.push(item)
        } else if (item.locationType == 4) {
          this.adv4.push(item)
        } else if (item.locationType == 5) {
          this.adv5.push(item)
        } else if (item.locationType == 6) {
          this.adv6.push(item)
        }
      })
      console.log(this.banner, 'banner')
    },
    async getSwiper() {
      let res = await this.$api.getIndexCharList()
      setTimeout(() => {
        loadSwiper();
      }, 100)
      this.swiper = res.data.data;
    },
    async getCards() {
      let res = await this.$api.getIndexImgList()
      this.cards = res.data.data
      setTimeout(() => {
        loadSwiper();
      }, 100)
    },
    // async getBulletin(){
    //   let res = await this.$api.getBulletin();
    //   // this.tab1 = res.data.data;
    //   // this.getTab1();
    // },
    async getTab1() {
      let res = await this.$api.getColumn({
        columnName: this.tab1[this.tabIndex1]
      })
      if (res.data.data) {
        this.tabData1 = res.data.data
      } else {
        this.tabData1 = []
      }

      console.log(this.tabData1)
    },
    //获取认证业务数据
    async getCert(name) {
      let res = await this.$api.getChildByColumn({columnName: name});
      console.log(res.data, '-------------------')
      this.certData = res.data.data
    },
    tabClick1(index) {
      this.tabIndex1 = index;
    },
    tabClick11(index) {
      this.tabIndex11 = index;
    },
    async gethydt() {
      let res = await this.$api.getColumn({columnName: '行业动态'});
      this.hydt = res.data.data;
    },
    async getgzdt() {
      let res = await this.$api.getColumn({columnName: '工作动态'});
      this.gzdt = res.data.data;
      console.log(this.gzdt)
    },
    async getTab2() {
      let res = await this.$api.getColumn({
        columnName: this.tab2[this.tabIndex2]
      })
      if (res.data.data) {
        this.tabData2 = res.data.data
      } else {
        this.tabData2 = []
      }
      console.log(this.tabData2)
    },
    tabClick2(index) {
      this.tabIndex2 = index;
      console.log(this.tabIndex2, 'this.tabIndex2');

      // this.getTab2()
    },
    async getPartner() {
      let res = await this.$api.getPartner();
      // console.log(res.data)
      this.partner = res.data.data
    },
    async getTab3() {
      let res = await this.$api.getColumn({
        columnName: this.tab3[this.tabIndex3]
      })
      if (res.data.data) {
        this.tabData3 = res.data.data[0]
      } else {
        this.tabData3 = []
      }
      console.log(this.tabData3, 'tabData3')
    },
    tabClick3(index) {
      this.tabIndex3 = index;
      // this.getTab3()
    },
    async getzspj() {
      let res = await this.$api.getColumn({columnName: '知识普及'});

      if (res.data.data) {
        this.zspj = res.data.data[0];
      } else {
        this.zspj = []
      }
      console.log(this.zspj)
    },
    async getFriendLink() {
      let res = await this.$api.getFriendLink();
      console.log(res.data)
      this.fLinks = res.data.data
    },
    toMore(item) {
      this.$router.push(`/channels/${item.topId}/${item.id}.html`)
    },
    toMore2(item, id) {
      this.$router.push(`/channels/${item.topId}/${id}.html`)
    },
    toDetail(item, id,ite) {
      console.log(item,name)
      // if (item.name == '证书公告') {
      //   return this.$router.push(`/channels/${item.topId}/${item.id}.html`)
      // }

      if(ite.type == 2){
        let url = process.env.VUE_APP_BASE_API + ite.fileUrl.replace(/^\//, '')
        window.open(url)
      }else{
        this.$router.push(`/contents/${item.topId}/${item.id}/${id}.html`)
      }
    },
    toDetail2(item) {
      if(item.type == 2){
        let url = process.env.VUE_APP_BASE_API + item.fileUrl.replace(/^\//, '')
        window.open(url)
      }else{
        this.$router.push(`/contents/${item.topId}/${item.columnId}/${item.id}.html`)
      }
    },
    setNavIndex(pid) {

    },
    navTo(item) {
      if (item.skipUrl.includes('http')) {
        window.open(item.skipUrl);
      } else {
        this.$router.push(item.skipUrl)
      }
    },
    getadd(item) {
      window.open(item.pathUrl)
    },
    getfindPhones() {
      this.$api.findPhones().then(res => {
        console.log(res.data.data)
        this.phonesList = res.data.data
      })
    },
    getBackgroundColor(index) {
      const blueColor = '#259FE0'
      const greenColor = '#53CCB4'

      const positionInGroup = index % 4
      return positionInGroup === 0 || positionInGroup === 3 ? blueColor : greenColor
    }
  }
}
</script>

<style scoped>
.img-hover-effect:hover {
  /* transform: scale(1.1) !important;  */
  background-size: 110% 110% !important;
  /* background-position: center; */
  transition: all 0.5s;
  z-index: 9999;
}

.box1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.box1 .box-item {
  width: 48%;
  height: 55px;
  border: 1px solid #d9e6ff;
  margin-bottom: 30px;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 16px;
  font-weight: bold;
}

.box-item:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-left: 8px solid #d9e6ff;
  height: 70%;
  margin: auto 0;
}

.box-item:nth-child(1) {
  margin-top: 15px;
}

.box-item:nth-child(2) {
  margin-top: 15px;

}

.btn {
  font-size: 14px;
  width: 80px;
  height: 26px;
  border-radius: 34px;
  display: block;
  background: #244991;
  color: #fff;
}

.cont_sec {
  margin-top: 30px;
  display: flex;
}

.cont_sec ul {
  display: flex;
}

.cont_sec ul li.item1 {

  cursor: pointer;
}

.cont_sec ul li {
  width: 245px;
  height: 89px;
  margin-right: 17px;
  display: flex;
  cursor: pointer;
  position: relative;
}

.cont_sec ul li:nth-child(4) {
  margin-right: 0;
}

.cont_sec ul li p.imgIcon {
  margin: 33px 0 29px;
}

.cont_sec ul li p.names {
  line-height: 88px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  margin-left: 12px;
  font-weight: bold;
}

.cont_sec ul li p.mengBan {
  opacity: 0.4;
}

.cont_sec ul li p.imgIcon img {
  width: 19px;
  height: 19px;
}

.fw {
  width: 1200px;
  height: 142px;
  background: #fff;
}

.fwimg {
  width: 45px;
  height: 44px;
  margin-top: 37px;
}

.fwul {
  margin-top: 27px;
}

.fw .title {
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  font-weight: bold;
  font-size: 19px;
  color: #1C3980;
  margin-left: 35px;
  margin-right: 41px;
}


.yw {
  width: 550px;
  height: 380px;
  background: #FFFFFF;
  border: 1px solid #E1E9F9;
  margin-left: 14px;
}

.yw .name {
  font-weight: 600;
  font-size: 20px;
  color: #14327C;
  padding: 25px 0 0 28px;
}

.yw .xian {
  width: 493px;
  background: #FFFFFF;
  border: 1px solid #ecf5ff;
  margin-left: 28px;
  margin-top: 17px;
  margin-bottom: 20px;
}

.yw .boxs2 {
  display: flex !important;
  padding-left: 28px !important;
  display: flex;
  flex-wrap: wrap;
  overflow-y: hidden;
  max-height: 285px;
}

.yw .boxs2 .nrr {
  display: flex !important;
  align-items: center;
  width: 234px;
  height: 74px;
  background: #259FE0;
  border-radius: 5px;
  margin-right: 25px;
  margin-bottom: 15px;
  padding: 0 !important;
}

.yw .boxs2 .nrr.adaptive {
  height: 57px !important;
  margin-bottom: 12px;
}

.yw .boxs2 .nrr.adaptive img {
  width: 35px;
  height: 35px;
  margin: 0 0 0 10px;
}

.yw .boxs2 .nrr.adaptive .title {
  font-size: 14px;
}

.yw .boxs2 .nrr img {
  width: 47px;
  height: 47px;
  margin: 0 0 0 10px;
}

.yw .boxs2 .nrr .title {
  font-weight: 400;
  font-size: 16px;
  color: #F3F3F5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 !important;
}

.yw .boxs2 .nrr:nth-child(2n) {
  margin-right: 0;
  background: #53CCB4;
}
</style>
